import Banner from '../components/banner';
import HeroSection from '../components/heroSection';
import OfferSection from '../components/offerSection';
import OurWork from '../components/ourWork';
import ReleationBanner from '../components/releationBanner';
import { Anulicense } from '../license';

const HomePage = () => {
  return (
    <div className="anuHome">
      <HeroSection/>
      <sectoin>
        <div className="bg-[#f5f6fa]">
          <div className="pt-10">
            <div className="container mx-auto px-10">
              <div className="flex justify-center mb-20 ">
                <div className="sm:w-1/2 w-full z-10 text-center relative">
                  <h4 className="lg:text-[24px] xl:text-[24px] md:text-[24px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] text-[18px] leading-[30px] font-bold font-secondary_font text-[#aa8210]">Our Core Features</h4>
                  <h2 className="lg:text-[50px] xl:text-[50px] md:text-[50px] text-[28px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] leading-[35px] font-medium">Experience Allows Us To Printing Things</h2>
                  <span className="font-secondary_font lg:text-[150px] xl:text-[150px] md:text-[150px] text-[90px] shadow-text">Features</span>
                </div>
              </div>
              <div className="flex flex-wrap gap-10 justify-center pb-40">
                <div className="stair_col xl:pt-[120px] lg:pt-[120px] md:pt-[120px]">
                  <div className="anu-feature_card">
                    <a href><img src={Anulicense.banner1} alt="img" /></a>
                    <div className="inline-flex flex-col justify-center items-center  w-full px-[15px] py-[30px]">
                      <span className="font-secondary_font text-[#ff4328] text-center">Any Type Of Printing</span>
                      <h3 className="font-global_font text-center font-medium text-[24px]">T-Shirts Prints</h3>
                    </div>
                  </div>
                </div>
                <div className="stair_col xl:pt-[60px] lg:pt-[60px] md:pt-[60px]">
                  <div className="anu-feature_card">
                    <a href><img src={Anulicense.ourWork23} alt="img" /></a>
                    <div className="inline-flex flex-col justify-center items-center w-full px-[15px] py-[30px]">
                      <span className="font-secondary_font text-[#ff4328] text-center">Any Type Of Printing</span>
                      <h3 className="font-global_font text-center font-medium text-[24px]">Roll-Up Standees</h3>
                    </div>
                  </div>
                </div>
                <div className="stair_col">
                  <div className="anu-feature_card">
                    <a href><img src={Anulicense.ourWork10} alt="img" /></a>
                    <div className="inline-flex flex-col justify-center items-center w-full px-[15px] py-[30px]">
                      <span className="font-secondary_font text-[#ff4328] text-center">Any Type Of Printing</span>
                      <h3 className="font-global_font text-center font-medium text-[24px]">Poster & Banner Design</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </sectoin>
      <div className="container">
        <div className="flex">
          <div className="bg-primary"></div>
          <div className='bg-secondary'></div>
        </div>
      </div>
      <Banner/>
      <OfferSection/>
      <ReleationBanner/>
      <OurWork/>
      {/* <StockImageDesign/> */}
      {/* <ClientSection/> */}
    </div>
  );
};

export default HomePage;